var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSendLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mail_outline_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4668",
    "data-name": "Pfad 4668",
    d: "M17,4H2.007L2,16H17ZM15.5,14.5H3.5V7l6,3.75L15.5,7Zm-6-5.25L3.5,5.5h12Z",
    transform: "translate(-0.5 -1)",
    fill: "#006b87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSendLink);
export default __webpack_public_path__ + "static/media/Icon_SendLink.7cbd9ac17883714086403ef95206e359.svg";
export { ForwardRef as ReactComponent };